class GeroSearchaniseCards {
  constructor() {
    this.PROCESSED_ATTR = "data-gero-stock-processed";
    this.PRICE_PROCESSED_ATTR = "data-gero-price-processed";
    this.IN_STOCK_ATTR = "data-gero-in-stock";
    this.PRODUCT_ID_ATTR = "data-original-product-id";
    this.METAFIELD_IDS = {
      outProduction: "variant_metafield_ae2c71305c2b1d12b03e9665d45450e0",
      emeubelDeliveryTermWeeks: "variant_metafield_6d854221c5589e9d32c2ce9f73ec0621",
      geroDeliveryTermWeeks: "variant_metafield_f4df058c2905bd5312b72255b8912206",
    };
    this.TITLE_OPTION_NAMES = ["breedte matras", "hoofdkleur"];
    this.productData = new Map();
  }

  isCadeaubon(item) {
    return (item.tags || "")
      .split("[:ATTR:]")
      .some((tag) => "cadeaubon" == tag.toLowerCase());
  }

  getVariantTitle(item, variant) {
    const options = (null != variant && variant.options) || {};

    for (const optionName of this.TITLE_OPTION_NAMES) {
      const match = Object.keys(options).find(
        (name) => name.trim().toLowerCase() == optionName,
      );
      if (null != match && "" != options[match]) {
        return `${item.title} - ${options[match]}`;
      }
    }

    return null;
  }

  parseCents(text) {
    const digits = (text || "").replace(/\D/g, "");
    if (3 > digits.length) {
      return null;
    }

    return parseInt(digits, 10);
  }

  formatPrice(cents) {
    const euros = Math.floor(cents / 100);
    const remainder = cents % 100;

    if (0 == remainder) {
      return euros + ",-";
    }

    return euros + ",<sup>" + String(remainder).padStart(2, "0") + "</sup>";
  }

  formatPriceElement(element) {
    const textNode = Array.from(element.childNodes).find(
      (node) => Node.TEXT_NODE == node.nodeType && "" != node.textContent.trim(),
    );
    if (null == textNode) {
      return;
    }

    const cents = this.parseCents(textNode.textContent);
    if (null == cents) {
      return;
    }

    const wrapper = document.createElement("span");
    wrapper.innerHTML = this.formatPrice(cents);
    textNode.replaceWith(...wrapper.childNodes);
  }

  formatPrices(priceList) {
    priceList
      .querySelectorAll(".snize-price, .snize-discounted-price")
      .forEach((element) => this.formatPriceElement(element));
  }

  cacheItem(item) {
    const variants = item.shopify_variants || [];
    const variant = variants[0];
    const metafields = (null != variant && variant.search_variant_metafields_data) || {};

    const deliveryTermWeeks =
      parseInt(metafields[this.METAFIELD_IDS.emeubelDeliveryTermWeeks], 10) ||
      parseInt(metafields[this.METAFIELD_IDS.geroDeliveryTermWeeks], 10) ||
      0;

    this.productData.set(String(item.original_product_id), {
      outProduction: "true" == metafields[this.METAFIELD_IDS.outProduction],
      deliveryTermWeeks: deliveryTermWeeks,
      cadeaubon: this.isCadeaubon(item),
      variantTitle: this.getVariantTitle(item, variant),
    });
  }

  cacheItems(data) {
    const items = (null != data && data.items) || [];
    items.forEach((item) => this.cacheItem(item));
  }

  interceptSnizeEvents() {
    GeroSnizeEvents.onDataRequest((type, data) => {
      if ("results" != type && "autocomplete" != type) {
        return;
      }
      this.cacheItems(data);
    });

    GeroSnizeEvents.onResults((container) => this.updateBadges(container));

    GeroSnizeEvents.onAutocomplete((container) => this.updateBadges(container));
  }

  getStatus(card, data) {
    if (data.cadeaubon) {
      return null;
    }

    if ("true" == card.getAttribute(this.IN_STOCK_ATTR)) {
      return { key: "in_stock" };
    }

    if (data.outProduction) {
      return { key: "not_available" };
    }

    return { key: "on_order", weeks: data.deliveryTermWeeks };
  }

  getBadge(status) {
    if (null == this.stockSource) {
      return null;
    }

    const template = this.stockSource.content.querySelector('[data-gero-stock-key="' + status.key + '"] .gero-stock-status');
    if (null == template) {
      return null;
    }
    const badge = template.cloneNode(true);
    if ("on_order" == status.key && 0 < status.weeks) {
      const textSpan = badge.querySelector(":scope > span.gero-stock-status > span.gero-stock-status:not([aria-hidden])");
      if (null != textSpan) {
        textSpan.textContent = "Binnen " + status.weeks + " weken bij jou thuis";
      }
    }
    return badge;
  }

  updatePrices(container) {
    container.querySelectorAll(".snize-price-list:not([" + this.PRICE_PROCESSED_ATTR + "])").forEach((priceList) => {
      priceList.setAttribute(this.PRICE_PROCESSED_ATTR, "true");
      this.formatPrices(priceList);
    });
  }

  updateBadges(container) {
    this.updatePrices(container);

    container.querySelectorAll(".snize-product").forEach((card) => {
      const inStockBadge = card.querySelector(".snize-in-stock");
      const outOfStockBadge = card.querySelector(".snize-out-of-stock");
      const inStockCount = null != inStockBadge ? parseInt(inStockBadge.textContent.trim(), 10) || 0 : 0;
      card.setAttribute(this.IN_STOCK_ATTR, 0 < inStockCount);

      if (null != inStockBadge) {
        inStockBadge.remove();
      }
      if (null != outOfStockBadge) {
        outOfStockBadge.remove();
      }
    });

    container.querySelectorAll(".snize-product:not([" + this.PROCESSED_ATTR + "])").forEach((card) => {
      const productId = card.getAttribute(this.PRODUCT_ID_ATTR);
      const data = null != productId ? this.productData.get(productId) : null;

      if (null == data) {
        return;
      }

      card.setAttribute(this.PROCESSED_ATTR, "true");

      const titleEl = card.querySelector(".snize-title");
      if (null != titleEl && null != data.variantTitle) {
        titleEl.textContent = data.variantTitle;
      }

      const status = this.getStatus(card, data);
      const badge = null != status ? this.getBadge(status) : null;
      const price = card.querySelector(".snize-price-list");

      if (null != price) {
        const insertBeforeNode = price.nextSibling;

        if (null != badge) {
          price.parentNode.insertBefore(badge, insertBeforeNode);
        }
      }
    });
  }

  init() {
    this.stockSource = document.getElementById("gero-searchanise-stock-status");

    if (null != this.stockSource) {
      this.stockSource.content.querySelectorAll("a.gero-stock-status").forEach((link) => {
        link.outerHTML = link.outerHTML.replace(/^<a/, "<span").replace(/<\/a>$/, "</span>");
      });
    }

    this.interceptSnizeEvents();
  }
}

if ("loading" == document.readyState) {
  document.addEventListener("DOMContentLoaded", () => {
    new GeroSearchaniseCards().init();
  });
} else {
  new GeroSearchaniseCards().init();
}
